import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ACCOUNT_VERIFICATION_ROUTE, getDefaultRouteForRole, isVerificationComplete, hasCapability } from '../../services/auth.service';

const ProtectedRoute = ({ children, allowedRoles, allowUnverified = false }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole');

  if (!token) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.some(hasCapability)) {
    return <Navigate to={getDefaultRouteForRole(userRole)} replace />;
  }

  if (!allowUnverified && !isVerificationComplete()) {
    return <Navigate to={ACCOUNT_VERIFICATION_ROUTE} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
